export const CONTENT_ASSIGNMENTS_CONFIG_KEY = 'contentAssignmentsConfig';
export const CONTENT_ASSIGNMENTS_KEY = 'contentAssignments';
export const CONTENT_ASSIGNMENT_SEED_KEY = 'contentAssignmentSeed';
export const CONTENT_ASSIGNMENT_TRACKING_KEY = 'contentAssignmentTracking';
